/** @paper-design/shaders-react@0.0.63 */

import { FlutedGlass as FlutedGlass1 } from "@paper-design/shaders-react";

/**
 * Code exported from Paper
 * https://app.paper.design/file/01K9TTZ4AGFQ5CAT83Y9N6K1XB?node=01K9TW1M1VFT0Q7BFQ7A3JS37K
 * on Nov 11, 2025 at 5:51 PM.
 */
export default function FlutedGlass({
	marginLeft = 0,
	angle = 140,
	imageUrl,
	width = 1456,
	height = 816,
}) {
	return (
		<FlutedGlass1
			size={0.8}
			// shape="linesIrregular"
			shape="wave"
			angle={angle}
			distortionShape="cascade"
			distortion={0.75}
			shift={-0.6}
			blur={0.25}
			edges={0.5}
			stretch={0}
			image={imageUrl} // Composite image with text
			scale={1}
			fit="contain"
			highlights={0.2}
			shadows={0.39}
			colorBack="#00000000"
			colorHighlight="#FFFFFF"
			colorShadow="#000000"
			marginLeft={marginLeft}
			marginRight={0}
			marginTop={0.1}
			marginBottom={0.1}
			style={{ height: `${height}px`, width: `${width}px` }}
		/>
	);
}
